function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clientErrorHandler } from '../..';
import { getTeamMenuItemConfigs, TAB_IDS, ACCOUNT_TYPES, USER_ROLES, SSO_STATE, TEAM_MEMBERSHIP_TYPE } from './teamMenuConstants';

// build the submenu items based on the current user package and role permissions
var _getSubMenuItems = function _getSubMenuItems(_ref) {
  var menuConfigs = _ref.menuConfigs,
    utSource = _ref.utSource;
  var menuItemConfigs = getTeamMenuItemConfigs(utSource);
  var menuItems = [menuConfigs.canAccess.teamSummaryTab && menuItemConfigs[TAB_IDS.teamSummary], menuConfigs.canAccess.manageUsersTab && menuItemConfigs[TAB_IDS.manageUsers], menuConfigs.canAccess.addUsersTab && menuItemConfigs[TAB_IDS.addUsers], menuConfigs.canAccess.adminDashboardTab && menuItemConfigs[TAB_IDS.adminDashboard], menuConfigs.canAccess.userReportTab && menuItemConfigs[TAB_IDS.userReport], menuConfigs.canAccess.divisionsTab && menuItemConfigs[TAB_IDS.divisions], menuConfigs.canAccess.workgroupsTab && menuItemConfigs[TAB_IDS.workgroups], menuConfigs.canAccess.libraryTab && menuItemConfigs[TAB_IDS.library], menuConfigs.canAccess.activityTab && menuItemConfigs[TAB_IDS.activity], menuConfigs.canAccess.offlineDevicesTab && menuItemConfigs[TAB_IDS.offlineDevices], menuConfigs.canAccess.manageCreditsTab && menuItemConfigs[TAB_IDS.manageCredits], menuConfigs.canAccess.manageCreditPoolsTab && menuItemConfigs[TAB_IDS.manageCreditPools], menuConfigs.canAccess.settingsTab && menuItemConfigs[TAB_IDS.settings], menuConfigs.canAccess.deiReportingTab && menuItemConfigs[TAB_IDS.dei_reporting]];
  return menuItems.filter(Boolean);
};

// spell out all the combination of userPackage/role
// to better understand what the user can and cant see in the ui
var _buildMenuConfigs = function _buildMenuConfigs(_ref2) {
  var features = _ref2.features,
    _ref2$isSSOEnabled = _ref2.isSSOEnabled,
    isSSOEnabled = _ref2$isSSOEnabled === void 0 ? false : _ref2$isSSOEnabled,
    _ref2$isAdminImperson = _ref2.isAdminImpersonated,
    isAdminImpersonated = _ref2$isAdminImperson === void 0 ? false : _ref2$isAdminImperson,
    _ref2$divisionAdminsC = _ref2.divisionAdminsCanManageUsers,
    divisionAdminsCanManageUsers = _ref2$divisionAdminsC === void 0 ? false : _ref2$divisionAdminsC,
    _ref2$permissions = _ref2.permissions,
    audienceCreditsManagePermission = _ref2$permissions.audienceCreditsManage,
    audienceCreditsManageCreditPoolsPermission = _ref2$permissions.audienceCreditsManageCreditPools,
    teamSummaryPermission = _ref2$permissions.teamSummary,
    manageUsersPermission = _ref2$permissions.manageUsers,
    addUsersPermission = _ref2$permissions.addUsers,
    divisionPermission = _ref2$permissions.division,
    workgroupPermission = _ref2$permissions.workgroup,
    activityPermission = _ref2$permissions.activity,
    offlineDevicesPermission = _ref2$permissions.offlineDevices,
    adminDashboardPermission = _ref2$permissions.adminDashboard,
    userReportPermission = _ref2$permissions.userReport,
    libraryPermission = _ref2$permissions.library;
  var defaultTabs = {
    teamSummaryTab: teamSummaryPermission,
    manageUsersTab: manageUsersPermission,
    addUsersTab: addUsersPermission && !isSSOEnabled,
    // SSO can't see Add Users tab, only button on header
    adminDashboardTab: features.adminDashboardEnabled && adminDashboardPermission && !userReportPermission,
    userReportTab: userReportPermission,
    divisionsTab: features.divisionsEnabled && divisionPermission,
    workgroupsTab: features.workgroupsEnabled && workgroupPermission,
    activityTab: features.auditLogsEnabled && activityPermission,
    offlineDevicesTab: features.offlineEnterpriseEnabled && offlineDevicesPermission,
    manageCreditsTab: features.teamAudienceCreditsEnabled && audienceCreditsManagePermission && !features.audienceCreditPoolsEnabled && !audienceCreditsManageCreditPoolsPermission,
    manageCreditPoolsTab: features.audienceCreditPoolsEnabled && audienceCreditsManageCreditPoolsPermission,
    libraryTab: libraryPermission,
    settings: false
  };
  return {
    enterpriseAccount: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(USER_ROLES.accountOwner), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        activityTab: defaultTabs.activityTab || isAdminImpersonated,
        deiReportingTab: features.deiReporting,
        settingsTab: true
      })
    }), "".concat(USER_ROLES.admin), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        activityTab: defaultTabs.activityTab || isAdminImpersonated,
        deiReportingTab: features.deiReporting,
        settingsTab: true
      })
    }), "".concat(USER_ROLES.divisionAdmin), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        manageUsersTab: defaultTabs.manageUsersTab || divisionAdminsCanManageUsers,
        activityTab: defaultTabs.activityTab || isAdminImpersonated,
        deiReportingTab: features.deiReporting
      })
    }), "".concat(USER_ROLES.user), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        deiReportingTab: features.deiReporting
      })
    }), "".concat(USER_ROLES.casual), {
      canAccess: defaultTabs
    }),
    teamAccount: _defineProperty(_defineProperty(_defineProperty({}, "".concat(USER_ROLES.accountOwner), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        deiReportingTab: features.deiReporting
      })
    }), "".concat(USER_ROLES.admin), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        deiReportingTab: features.deiReporting
      })
    }), "".concat(USER_ROLES.user), {
      canAccess: _objectSpread(_objectSpread({}, defaultTabs), {}, {
        deiReportingTab: features.deiReporting
      })
    })
  };
};
var _getMenuItems = function _getMenuItems(_ref3) {
  var _user$team$settings$d, _user$team;
  var user = _ref3.user,
    session = _ref3.session,
    utSource = _ref3.utSource,
    permissions = _ref3.permissions;
  var team = user.team || {};
  var teamMembership = user.teamMembership || {};
  // I will work on conforming the mobile and desktop calls because
  // session is passed in in 2 different ways currently
  var userSession = session || user.session;
  var isAdminImpersonated = userSession && userSession.isAdminImpersonation;
  var isAdmin = teamMembership.isAdmin,
    isDivisionAdmin = teamMembership.isDivisionAdmin;
  var isSSOEnabled = team.ssoState === SSO_STATE.REQUIRED;
  var isTeamOwner = teamMembership.memberType === TEAM_MEMBERSHIP_TYPE.ACCOUNT_OWNER;
  var isCasual = teamMembership.memberType === TEAM_MEMBERSHIP_TYPE.CASUAL;
  var features = user.features || {};
  var isEnterpriseAccount = teamMembership.isEnterprise;
  var isTeamAccount = !teamMembership.isEnterprise;
  var divisionAdminsCanManageUsers = (_user$team$settings$d = user === null || user === void 0 || (_user$team = user.team) === null || _user$team === void 0 || (_user$team = _user$team.settings) === null || _user$team === void 0 ? void 0 : _user$team.divisionAdminsCanManageUsers) !== null && _user$team$settings$d !== void 0 ? _user$team$settings$d : false;
  var userAccountType = '';
  if (isEnterpriseAccount) {
    // enterprise package 26 accounts
    userAccountType = ACCOUNT_TYPES.enterpriseAccount;
  } else if (isTeamAccount) {
    // self serve teams
    userAccountType = ACCOUNT_TYPES.teamAccount;
  }
  var userRole = '';
  if (isTeamOwner) {
    userRole = USER_ROLES.accountOwner;
  } else if (isAdmin) {
    userRole = USER_ROLES.admin;
  } else if (isDivisionAdmin) {
    userRole = USER_ROLES.divisionAdmin;
  } else if (isCasual) {
    userRole = USER_ROLES.casual;
  } else {
    userRole = USER_ROLES.user;
  }
  var validUserAccountAndRole = !!userAccountType && !!userRole;
  if (validUserAccountAndRole) {
    try {
      var menuConfigs = _buildMenuConfigs({
        features: features,
        isSSOEnabled: isSSOEnabled,
        isAdminImpersonated: isAdminImpersonated,
        divisionAdminsCanManageUsers: divisionAdminsCanManageUsers,
        permissions: permissions
      })[userAccountType][userRole];
      // return only menu items the user have access to based on their
      // package/role
      return _getSubMenuItems({
        menuConfigs: menuConfigs,
        utSource: utSource
      });
    } catch (e) {
      // This should not occur, however it is a fallback in case we introduce
      // some new user account type
      clientErrorHandler.logError(e, 'Unexpected error while building My Team menu items', {
        userAccountType: userAccountType,
        userRole: userRole,
        features: features,
        isSSOEnabled: isSSOEnabled,
        isAdminImpersonated: isAdminImpersonated
      });
      return [];
    }
  }
  return [];
};
var getMyTeamMenuItems = function getMyTeamMenuItems(_ref4) {
  var user = _ref4.user,
    _ref4$session = _ref4.session,
    session = _ref4$session === void 0 ? {} : _ref4$session,
    _ref4$utSource = _ref4.utSource,
    utSource = _ref4$utSource === void 0 ? 'header' : _ref4$utSource,
    _ref4$permissions = _ref4.permissions,
    permissions = _ref4$permissions === void 0 ? {} : _ref4$permissions;
  if (!user) {
    return [];
  }
  return _getMenuItems({
    user: user,
    session: session,
    utSource: utSource,
    permissions: permissions
  });
};
export default getMyTeamMenuItems;
//# sourceMappingURL=index.js.map